import { render } from "./MaintenanceScheduleCreate.vue?vue&type=template&id=4a747d24&ts=true"
import script from "./MaintenanceScheduleCreate.vue?vue&type=script&lang=ts"
export * from "./MaintenanceScheduleCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__